import Dropdown from "@/components/global/menus/Dropdown";
import AddIcon from "@/components/icons/AddIcon";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import { getProductVariant } from "@/helpers/productDetails";

const BundleTitlePrice = ({ parentProduct, parentQty, setParentQty }) => {
  // Handling configurable product type
  const productVariant = getProductVariant(parentProduct);
  return (
    <div className="flex flex-col gap-3 overflow-visible max-sm:gap-1">
      <div className="flex gap-2 overflow-visible">
        {/* Quantity selector for responsive layout */}
        <h1 className="text-xl max-sm:text-[11px] max-sm:leading-4 font-bold">
          {productVariant?.name || parentProduct?.name}
        </h1>
        <div className="hidden overflow-visible max-sm:block">
          <Dropdown
            options={Array(20)
              .fill(0)
              .map((e, i) => ({ label: i + 1, value: i + 1 }))}
            defaultValue={{ label: 1, value: 1 }}
            onChange={(e) => {
              setParentQty(e.value);
            }}
            selectedOption={{ label: parentQty, value: parentQty }}
          />
        </div>
      </div>
      <div className="flex items-center gap-5">
        <p className="text-[#4861A7] flex items-center gap-1 text-xl max-sm:text-[11px] font-bold">
          {parentProduct?.prices_with_tax?.price}{" "}
          <CurrencyIcon className="size-3.5" />
        </p>
        {parentProduct?.prices_with_tax?.price <
          parentProduct?.prices_with_tax?.original_price && (
          <p className="line-through text-lg max-sm:text-xs flex items-center gap-1 text-[#B4AFAF] font-medium">
            {parentProduct?.prices_with_tax?.original_price}{" "}
            <CurrencyIcon className="size-3.5" />
          </p>
        )}
      </div>
      {/* <ProductConfigurations product={parentProduct} setProduct={setParentProduct} t={t} />  */}
      <div className="flex items-center max-sm:hidden">
        <button
          onClick={() => setParentQty(parentQty - 1)}
          disabled={parentQty == 1}
          className="bg-[#EAE8E880] h-10 w-10 grid place-items-center"
        >
          <MinusIcon />
        </button>

        <span className="flex items-center justify-center w-16 border-t border-b py-[7px]">
          {parentQty}
        </span>

        <button
          onClick={() => setParentQty(parentQty + 1)}
          className="bg-[#EAE8E880] h-10 w-10 grid place-items-center"
        >
          <AddIcon />
        </button>
      </div>
      <div></div>
    </div>
  );
};

export default BundleTitlePrice;
